<div fxLayout="row">
    <div class="pending-version-label">
        {{ item.pendingFirmwareVersion | hardwareVersion }}
    </div>
    <div *ngIf="isStatusAvailable && !stateIsBusy">
        <mat-icon class="status-icon"
                  [ngClass]="state?.cls"
                  [matTooltip]="state?.statusDescription"
                  [matTooltipPosition]="tooltipDirection">
            {{ state?.icon }}
        </mat-icon>
    </div>
    <div class="firmware-progress-indicator relative"
         *ngIf="isStatusAvailable && stateIsBusy">
        <mat-progress-spinner color="accent"
                              [mode]="versionProgressMode"
                              [value]="versionProgressValue"
                              [diameter]="25"></mat-progress-spinner>
        <span class="absolute">{{ versionProgressValue }}%</span>
    </div>
</div> 